function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M212.5 7.2V0h-28.1v7.2H99.1V0H70.9v7.2H0v269h283.5V7.2h-71zm42.8 241H28.1V99.4h227.2v148.8zm0-177.7H28.1V35.3h42.8v14.3H99V35.3h85.4v14.3h28.1V35.3h42.8v35.2zm-96.1 72.1H95.1v-22.3h93.2v22.3c-28.1 37.5-40.4 61.3-48.5 84h-31.3c7.3-21.7 18.8-44.5 50.7-84z"
})));